import * as z from 'zod';

export const zAdminDashboard_UsersWidget_ByEnum = z.enum(['day', 'month'] as const);
export const adminDashboard_UsersWidget_ByEnumValues: readonly z.infer<
    typeof zAdminDashboard_UsersWidget_ByEnum
>[] = ['day', 'month'] as const;
export const zBumpDirectionEnum = z.enum(['down', 'up'] as const);
export const bumpDirectionEnumValues: readonly z.infer<typeof zBumpDirectionEnum>[] = [
    'down',
    'up',
] as const;
export const zCareerStatusEnum = z.enum([
    'active_job_search',
    'closed_to_opportunities',
    'open_to_opportunities',
] as const);
export const careerStatusEnumValues: readonly z.infer<typeof zCareerStatusEnum>[] = [
    'active_job_search',
    'closed_to_opportunities',
    'open_to_opportunities',
] as const;
export const zCategoryOrderFieldEnum = z.enum(['id', 'name', 'rank'] as const);
export const categoryOrderFieldEnumValues: readonly z.infer<
    typeof zCategoryOrderFieldEnum
>[] = ['id', 'name', 'rank'] as const;
export const zCompanyManagerRoleEnum = z.enum(['admin', 'editor'] as const);
export const companyManagerRoleEnumValues: readonly z.infer<
    typeof zCompanyManagerRoleEnum
>[] = ['admin', 'editor'] as const;
export const zCompanyMediaSlotEnum = z.enum([
    'banner',
    'bannerMobile',
    'square',
] as const);
export const companyMediaSlotEnumValues: readonly z.infer<
    typeof zCompanyMediaSlotEnum
>[] = ['banner', 'bannerMobile', 'square'] as const;
export const zCompanyOrUserMediaSlotEnum = z.enum([
    'banner',
    'bannerMobile',
    'profile',
    'profileBg',
    'square',
] as const);
export const companyOrUserMediaSlotEnumValues: readonly z.infer<
    typeof zCompanyOrUserMediaSlotEnum
>[] = ['banner', 'bannerMobile', 'profile', 'profileBg', 'square'] as const;
export const zCoordinateTypeEnum = z.enum(['fax', 'gsm', 'tel'] as const);
export const coordinateTypeEnumValues: readonly z.infer<typeof zCoordinateTypeEnum>[] = [
    'fax',
    'gsm',
    'tel',
] as const;
export const zEducationLevelEnum = z.enum([
    'bac',
    'bac_plus_1',
    'bac_plus_2',
    'bac_plus_3',
    'bac_plus_4',
    'bac_plus_5',
    'bep_cap',
    'none',
] as const);
export const educationLevelEnumValues: readonly z.infer<typeof zEducationLevelEnum>[] = [
    'bac',
    'bac_plus_1',
    'bac_plus_2',
    'bac_plus_3',
    'bac_plus_4',
    'bac_plus_5',
    'bep_cap',
    'none',
] as const;
export const zExperienceLevelEnum = z.enum([
    'from_0_plus',
    'from_0_to_2',
    'from_1_plus',
    'from_2_plus',
    'from_2_to_5',
    'from_3_plus',
    'from_4_plus',
    'from_5_plus',
    'from_6_plus',
    'from_7_plus',
    'from_8_plus',
    'from_9_plus',
    'from_10_plus',
] as const);
export const experienceLevelEnumValues: readonly z.infer<typeof zExperienceLevelEnum>[] =
    [
        'from_0_plus',
        'from_0_to_2',
        'from_1_plus',
        'from_2_plus',
        'from_2_to_5',
        'from_3_plus',
        'from_4_plus',
        'from_5_plus',
        'from_6_plus',
        'from_7_plus',
        'from_8_plus',
        'from_9_plus',
        'from_10_plus',
    ] as const;
export const zFeedPostTagEnum = z.enum([
    'classifieds',
    'event',
    'info',
    'job',
    'product',
    'product__baby_and_toys',
    'product__beauty_andhealth',
    'product__clothing_and_shoes',
    'product__computer_science',
    'product__furniture_an_doffice',
    'product__garden_and_animals_and_outdoors',
    'product__home_and_kitchen',
    'product__home_appliance',
    'product__phones_and_tablets',
    'product__sports_and_leisure',
    'product__tv_and_hi_tech',
    'product__video_games_and_consoles',
    'product_or_service',
    'professional_equipment',
    'professional_equipment__agricultural_material',
    'professional_equipment__construction_structural_work',
    'professional_equipment__equipment_for_businesses',
    'professional_equipment__equipment_for_restaurants_and_hotels',
    'professional_equipment__heavyweight',
    'professional_equipment__industrial_equipment',
    'professional_equipment__lifting_equipment',
    'professional_equipment__medical_equipment',
    'professional_equipment__tractors',
    'promo',
    'real_estate',
    'real_estate_new',
    'real_estate_offices_and_shops',
    'real_estate_rentals',
    'real_estate_roommates',
    'real_estate_sales',
    'service',
    'training',
    'vehicle',
    'vehicle__boats_boating',
    'vehicle__cars',
    'vehicle__motorcycles',
    'vehicle__trucks',
    'vehicle__utilities',
] as const);
export const feedPostTagEnumValues: readonly z.infer<typeof zFeedPostTagEnum>[] = [
    'classifieds',
    'event',
    'info',
    'job',
    'product',
    'product__baby_and_toys',
    'product__beauty_andhealth',
    'product__clothing_and_shoes',
    'product__computer_science',
    'product__furniture_an_doffice',
    'product__garden_and_animals_and_outdoors',
    'product__home_and_kitchen',
    'product__home_appliance',
    'product__phones_and_tablets',
    'product__sports_and_leisure',
    'product__tv_and_hi_tech',
    'product__video_games_and_consoles',
    'product_or_service',
    'professional_equipment',
    'professional_equipment__agricultural_material',
    'professional_equipment__construction_structural_work',
    'professional_equipment__equipment_for_businesses',
    'professional_equipment__equipment_for_restaurants_and_hotels',
    'professional_equipment__heavyweight',
    'professional_equipment__industrial_equipment',
    'professional_equipment__lifting_equipment',
    'professional_equipment__medical_equipment',
    'professional_equipment__tractors',
    'promo',
    'real_estate',
    'real_estate_new',
    'real_estate_offices_and_shops',
    'real_estate_rentals',
    'real_estate_roommates',
    'real_estate_sales',
    'service',
    'training',
    'vehicle',
    'vehicle__boats_boating',
    'vehicle__cars',
    'vehicle__motorcycles',
    'vehicle__trucks',
    'vehicle__utilities',
] as const;
export const zJobContractTypeEnum = z.enum([
    'apprenticeship_alternation',
    'cdd',
    'cdi',
    'freelance',
    'interim',
    'internship',
    'volunteering',
] as const);
export const jobContractTypeEnumValues: readonly z.infer<typeof zJobContractTypeEnum>[] =
    [
        'apprenticeship_alternation',
        'cdd',
        'cdi',
        'freelance',
        'interim',
        'internship',
        'volunteering',
    ] as const;
export const zJobRemoteEnum = z.enum(['full', 'none', 'occasional', 'partial'] as const);
export const jobRemoteEnumValues: readonly z.infer<typeof zJobRemoteEnum>[] = [
    'full',
    'none',
    'occasional',
    'partial',
] as const;
export const zJobSalaryPeriodEnum = z.enum(['day', 'hour', 'month', 'year'] as const);
export const jobSalaryPeriodEnumValues: readonly z.infer<typeof zJobSalaryPeriodEnum>[] =
    ['day', 'hour', 'month', 'year'] as const;
export const zJobStatusEnum = z.enum([
    'employee',
    'entrepreneur',
    'executive',
    'freelance',
    'leader',
    'student',
] as const);
export const jobStatusEnumValues: readonly z.infer<typeof zJobStatusEnum>[] = [
    'employee',
    'entrepreneur',
    'executive',
    'freelance',
    'leader',
    'student',
] as const;
export const zJobWorkTimeEnum = z.enum(['full_time', 'part_time'] as const);
export const jobWorkTimeEnumValues: readonly z.infer<typeof zJobWorkTimeEnum>[] = [
    'full_time',
    'part_time',
] as const;
export const zLangLevelEnum = z.enum([
    'knowledge',
    'native',
    'pro',
    'pro_full',
    'pro_limited',
] as const);
export const langLevelEnumValues: readonly z.infer<typeof zLangLevelEnum>[] = [
    'knowledge',
    'native',
    'pro',
    'pro_full',
    'pro_limited',
] as const;
export const zNotificationTypeEnum = z.enum([
    'alert_on_company',
    'feed_comment_mention',
    'feed_comment_reply',
    'feed_post_comment',
    'feed_post_reaction',
    'feed_post_share',
    'new_follower',
] as const);
export const notificationTypeEnumValues: readonly z.infer<
    typeof zNotificationTypeEnum
>[] = [
    'alert_on_company',
    'feed_comment_mention',
    'feed_comment_reply',
    'feed_post_comment',
    'feed_post_reaction',
    'feed_post_share',
    'new_follower',
] as const;
export const zOrderByDirectionEnum = z.enum(['asc', 'desc'] as const);
export const orderByDirectionEnumValues: readonly z.infer<
    typeof zOrderByDirectionEnum
>[] = ['asc', 'desc'] as const;
export const zSearchHeaderFormData_FreelancerEnum = z.enum([
    'all',
    'with',
    'without',
] as const);
export const searchHeaderFormData_FreelancerEnumValues: readonly z.infer<
    typeof zSearchHeaderFormData_FreelancerEnum
>[] = ['all', 'with', 'without'] as const;
export const zSearchHeaderFormData_JobContentEnum = z.enum(['with_media'] as const);
export const searchHeaderFormData_JobContentEnumValues: readonly z.infer<
    typeof zSearchHeaderFormData_JobContentEnum
>[] = ['with_media'] as const;
export const zSearchHeaderFormData_JobPublicationDateEnum = z.enum([
    'all_dates',
    'last_3_days',
    'last_24_hours',
    'last_month',
    'last_week',
] as const);
export const searchHeaderFormData_JobPublicationDateEnumValues: readonly z.infer<
    typeof zSearchHeaderFormData_JobPublicationDateEnum
>[] = ['all_dates', 'last_3_days', 'last_24_hours', 'last_month', 'last_week'] as const;
export const zSearchHeaderFormData_ProfileContentEnum = z.enum([
    'with_cv',
    'with_experiences',
    'with_formations',
    'with_video',
] as const);
export const searchHeaderFormData_ProfileContentEnumValues: readonly z.infer<
    typeof zSearchHeaderFormData_ProfileContentEnum
>[] = ['with_cv', 'with_experiences', 'with_formations', 'with_video'] as const;
export const zSearchHeaderFormData_TypeEnum = z.enum([
    'company',
    'job',
    'newsfeed',
    'pro',
] as const);
export const searchHeaderFormData_TypeEnumValues: readonly z.infer<
    typeof zSearchHeaderFormData_TypeEnum
>[] = ['company', 'job', 'newsfeed', 'pro'] as const;
export const zSexEnum = z.enum(['F', 'H'] as const);
export const sexEnumValues: readonly z.infer<typeof zSexEnum>[] = ['F', 'H'] as const;
export const zSocialNetworkTypeEnum = z.enum([
    'facebook',
    'instagram',
    'jumia',
    'linkedin',
    'tiktok',
    'twitter',
    'website',
    'youtube',
] as const);
export const socialNetworkTypeEnumValues: readonly z.infer<
    typeof zSocialNetworkTypeEnum
>[] = [
    'facebook',
    'instagram',
    'jumia',
    'linkedin',
    'tiktok',
    'twitter',
    'website',
    'youtube',
] as const;
export const zThreadTypeEnum = z.enum(['talent_multi_message'] as const);
export const threadTypeEnumValues: readonly z.infer<typeof zThreadTypeEnum>[] = [
    'talent_multi_message',
] as const;
export const zUserCoordinateTypeEnum = z.enum([
    'email',
    'facebook',
    'fax',
    'gsm',
    'instagram',
    'jumia',
    'linkedin',
    'tel',
    'tiktok',
    'twitter',
    'website',
    'whatsapp',
] as const);
export const userCoordinateTypeEnumValues: readonly z.infer<
    typeof zUserCoordinateTypeEnum
>[] = [
    'email',
    'facebook',
    'fax',
    'gsm',
    'instagram',
    'jumia',
    'linkedin',
    'tel',
    'tiktok',
    'twitter',
    'website',
    'whatsapp',
] as const;
export const zUserMediaSlotEnum = z.enum(['profile', 'profileBg'] as const);
export const userMediaSlotEnumValues: readonly z.infer<typeof zUserMediaSlotEnum>[] = [
    'profile',
    'profileBg',
] as const;
export const zUserPhotoStatusEnum = z.enum([
    'deleted',
    'no',
    'valid',
    'waiting',
] as const);
export const userPhotoStatusEnumValues: readonly z.infer<typeof zUserPhotoStatusEnum>[] =
    ['deleted', 'no', 'valid', 'waiting'] as const;
